<template>
  <div class="lots-filter">
    <bp-select
      v-model="form.status"
      label="Status"
      placeholder="Selecione o tipo"
      :options="[
        { id: '', name: 'Todos' },
        { id: 'enabled', name: 'Ativo' },
        { id: 'canceled', name: 'Inativo' }
      ]"
    />
    <div class="row mt-6 pt-3">
      <div class="d-none d-lg-block col-6" />
      <div class="col-12 col-lg-3 mb-5 order-1 order-lg-2 px-3">
        <button class="btn btn-40 btn-primary-500 btn-block" @click="apply">
          Aplicar
        </button>
      </div>
      <div class="col-12 col-lg-3 order-2 order-lg-1 px-3">
        <button
          class="btn btn-40 btn-neutral-1 btn-block"
          @click="$emit('close')"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
export default {
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      ...formFields(["status"], this.value)
    };
  },
  methods: {
    apply() {
      this.$emit("input", this.form);
      this.$emit("close");
    }
  }
};
</script>
